import { useEffect, useRef } from 'react';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
export const useCardViewTracking = ({
  name
}) => {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const cardRef = useRef(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    var _cardRef$current;
    if (!cardRef.current || hasTracked.current) {
      return;
    }
    const cardHeight = ((_cardRef$current = cardRef.current) === null || _cardRef$current === void 0 ? void 0 : _cardRef$current.offsetHeight) || 0;
    const windowHeight = window.innerHeight;
    const defaultThreshold = 0.75;
    const calculatedThreshold = cardHeight > windowHeight / defaultThreshold ? windowHeight * defaultThreshold / cardHeight : defaultThreshold;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasTracked.current) {
        trackInteraction({
          action: 'card viewed',
          section: name
        });
        hasTracked.current = true;
        observer.disconnect();
      }
    }, {
      threshold: calculatedThreshold
    });
    observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [name, trackInteraction]);
  return cardRef;
};